import type { StoreWithDistance } from '@context/StoresContext';
import { getDistanceFromShopperToStore } from './getDistanceFromShopperToStore';

/** Same ordering as {@link FindInStoreSection} preview list: shopper distance when geo is valid, else original order. */
export function sortPreviewStoresByShopperGeolocation(
  previewStores: StoreWithDistance[],
  shopperGeolocation?: { latitude: number; longitude: number } | null
): StoreWithDistance[] {
  if (!previewStores.length) {
    return previewStores;
  }

  const storeDistanceMap = new Map<string, number>();
  previewStores.forEach((store) => {
    const { mec_store_id: storeId } = store.data;
    const distance =
      getDistanceFromShopperToStore(store, shopperGeolocation) ??
      Number.POSITIVE_INFINITY;
    storeDistanceMap.set(storeId, distance);
  });

  return [...previewStores].sort((a, b) => {
    const aDistance =
      storeDistanceMap.get(a.data.mec_store_id) ?? Number.POSITIVE_INFINITY;
    const bDistance =
      storeDistanceMap.get(b.data.mec_store_id) ?? Number.POSITIVE_INFINITY;
    return aDistance - bDistance;
  });
}
